import { createContext, useState } from "react";
import { appConfig } from "./AppConfig";

//hostnames
let test = "waterlink-test.utah.gov";

// Check if running in Cypress
const isCypress = window.Cypress && window.Cypress.env("ENV") === "cypress";

export const getEnvironment = () => {
  if (isCypress) {
    return test; // TODO: change this to a hosted dev link
  }

  return appConfig.env;
}
export const EnvironmentContext = createContext();

export const EnvironmentProvider = ({ children }) => {
  const [env, setEnv] = useState(getEnvironment);

  /*useEffect(() => {
    // Optionally, you can perform any side effects related to environment changes here
    // For example, you might want to fetch some data based on the environment
  }, [env]);*/

  return <EnvironmentContext.Provider value={{ env, setEnv }}>{children}</EnvironmentContext.Provider>;
};
